/*
 * Bakehouse visit section: live open/closed status (Eastern time, parsed from the
 * hours text), today-highlight in the hours list, mobile sticky action bar, and
 * Statsig logging of every Bakehouse CTA click on the page.
 */
(function () {
  var TZ = 'America/New_York';
  var DAYS = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
  var DAY_ALIASES = { sun: 0, mon: 1, tue: 2, tues: 2, wed: 3, thu: 4, thur: 4, thurs: 4, fri: 5, sat: 6 };

  function dayIndex(token) {
    var t = String(token || '').trim().toLowerCase().replace(/\./g, '');
    if (!t) return -1;
    for (var i = 0; i < DAYS.length; i++) if (DAYS[i] === t || DAYS[i].slice(0, 3) === t.slice(0, 3)) return i;
    return DAY_ALIASES.hasOwnProperty(t) ? DAY_ALIASES[t] : -1;
  }

  // "7 AM", "6:30 PM", "7am", "12 PM", "noon", "midnight" -> minutes since midnight
  function parseTime(str) {
    var s = String(str || '').trim().toLowerCase();
    if (!s) return null;
    if (s === 'noon') return 12 * 60;
    if (s === 'midnight') return 0;
    var m = s.match(/^(\d{1,2})(?::(\d{2}))?\s*([ap])\.?m?\.?$/);
    if (!m) {
      var m24 = s.match(/^(\d{1,2}):(\d{2})$/);
      if (!m24) return null;
      return parseInt(m24[1], 10) * 60 + parseInt(m24[2], 10);
    }
    var h = parseInt(m[1], 10) % 12;
    if (m[3] === 'p') h += 12;
    return h * 60 + (m[2] ? parseInt(m[2], 10) : 0);
  }

  // Lines like "Monday - Wednesday: 7 AM - 2 PM", "Sunday: 8 AM - 2 PM", "Monday: Closed"
  // -> schedule[dayIndex] = { open, close, lineIndex } or { closed: true, lineIndex }
  function parseHours(text) {
    var schedule = {};
    var lines = String(text || '').split(/\r?\n/);
    lines.forEach(function (raw, lineIndex) {
      var line = raw.trim();
      if (!line) return;
      var colon = line.indexOf(': ');
      if (colon < 0) colon = line.indexOf(':');
      if (colon < 0) return;
      var daysPart = line.slice(0, colon).trim();
      var timePart = line.slice(colon + 1).trim();
      var days = [];
      daysPart.split(/\s*(?:,|&|and)\s*/i).forEach(function (chunk) {
        var range = chunk.split(/\s*[-–—]\s*|\s+to\s+/i);
        var a = dayIndex(range[0]);
        var b = range.length > 1 ? dayIndex(range[range.length - 1]) : a;
        if (a < 0) return;
        if (b < 0) b = a;
        var d = a;
        for (var guard = 0; guard < 7; guard++) {
          days.push(d);
          if (d === b) break;
          d = (d + 1) % 7;
        }
      });
      if (!days.length) return;
      var entry;
      if (/closed/i.test(timePart)) {
        entry = { closed: true, lineIndex: lineIndex };
      } else {
        var times = timePart.split(/\s*[-–—]\s*|\s+to\s+/i);
        var open = parseTime(times[0]);
        var close = parseTime(times[1]);
        if (open == null || close == null) return;
        entry = { open: open, close: close, lineIndex: lineIndex };
      }
      days.forEach(function (d) { schedule[d] = entry; });
    });
    return schedule;
  }

  function nowInEastern() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: TZ, weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(new Date());
    var out = {};
    parts.forEach(function (p) { out[p.type] = p.value; });
    var hour = parseInt(out.hour, 10) % 24; // some engines emit "24" at midnight
    return { day: dayIndex(out.weekday), minutes: hour * 60 + parseInt(out.minute, 10) };
  }

  function fmt(minutes) {
    var h = Math.floor(minutes / 60) % 24, m = minutes % 60;
    var suffix = h >= 12 ? 'PM' : 'AM';
    var hh = h % 12 === 0 ? 12 : h % 12;
    return hh + (m ? ':' + (m < 10 ? '0' + m : m) : '') + ' ' + suffix;
  }

  function dayLabel(offset, idx) {
    if (offset === 0) return 'today';
    if (offset === 1) return 'tomorrow';
    return DAYS[idx].charAt(0).toUpperCase() + DAYS[idx].slice(1);
  }

  function computeStatus(schedule) {
    var now = nowInEastern();
    if (now.day < 0) return null;
    var today = schedule[now.day];
    if (today && !today.closed && now.minutes >= today.open && now.minutes < today.close) {
      var left = today.close - now.minutes;
      return {
        state: left <= 60 ? 'closing' : 'open',
        text: (left <= 60 ? 'Closing soon' : 'Open now') + ' · Closes ' + fmt(today.close),
        todayLine: today.lineIndex
      };
    }
    // Closed: find the next opening within the week
    for (var offset = 0; offset < 8; offset++) {
      var idx = (now.day + offset) % 7;
      var e = schedule[idx];
      if (!e || e.closed) continue;
      if (offset === 0 && now.minutes >= e.open) continue;
      return {
        state: 'closed',
        text: 'Closed · Opens ' + dayLabel(offset, idx) + ' at ' + fmt(e.open),
        todayLine: today ? today.lineIndex : -1
      };
    }
    return { state: 'closed', text: 'Closed', todayLine: today ? today.lineIndex : -1 };
  }

  function initStatus(root) {
    var el = root.querySelector('[data-bh-status]');
    var textEl = root.querySelector('[data-bh-status-text]');
    if (!el || !textEl) return;
    var mode = root.getAttribute('data-status-mode') || 'auto';
    if (mode === 'hidden') return;
    var schedule = parseHours(root.getAttribute('data-hours'));
    var lines = root.querySelectorAll('[data-bh-hours-line]');
    try { initJsonLd(root, schedule); } catch (e) { /* structured data is best-effort */ }

    function render() {
      var status;
      if (mode === 'closed') {
        status = { state: 'closed', text: root.getAttribute('data-closed-message') || 'Closed today', todayLine: -1 };
        var t = schedule[nowInEastern().day];
        if (t) status.todayLine = t.lineIndex;
      } else {
        status = computeStatus(schedule);
      }
      if (!status) return;
      el.className = 'bakehouse-visit__status bakehouse-visit__status--' + status.state;
      textEl.textContent = status.text;
      el.hidden = false;
      for (var i = 0; i < lines.length; i++) {
        lines[i].classList.toggle('bakehouse-visit__hours-line--today', i === status.todayLine);
      }
    }
    try { render(); } catch (e) { /* leave the pill hidden */ }
    setInterval(function () { try { render(); } catch (e) {} }, 60 * 1000);
  }

  // schema.org Bakery structured data, built from the same hours text the pill uses
  function initJsonLd(root, schedule) {
    if (document.querySelector('script[data-bakehouse-jsonld]')) return;
    var name = root.getAttribute('data-ld-name');
    if (!name) return;
    var DAY_CODES = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];
    function hhmm(min) { var h = Math.floor(min / 60), m = min % 60; return (h < 10 ? '0' : '') + h + ':' + (m < 10 ? '0' : '') + m; }
    var spec = [];
    for (var d = 0; d < 7; d++) {
      var e = schedule[d];
      if (!e || e.closed) continue;
      spec.push({ '@type': 'OpeningHoursSpecification', dayOfWeek: 'https://schema.org/' + DAYS[d].charAt(0).toUpperCase() + DAYS[d].slice(1), opens: hhmm(e.open), closes: hhmm(e.close) });
    }
    var locality = root.getAttribute('data-ld-locality') || '';
    var m = locality.match(/^(.*?),\s*([A-Z]{2})\s*(\d{5})?/);
    var data = {
      '@context': 'https://schema.org',
      '@type': 'Bakery',
      name: name,
      url: window.location.origin + window.location.pathname,
      telephone: root.getAttribute('data-ld-phone') || undefined,
      hasMap: root.getAttribute('data-ld-maps') || undefined,
      menu: root.getAttribute('data-ld-menu') || undefined,
      address: {
        '@type': 'PostalAddress',
        streetAddress: root.getAttribute('data-ld-street'),
        addressLocality: m ? m[1] : locality,
        addressRegion: m ? m[2] : undefined,
        postalCode: m && m[3] ? m[3] : undefined,
        addressCountry: 'US'
      },
      openingHoursSpecification: spec.length ? spec : undefined
    };
    var lat = parseFloat(root.getAttribute('data-ld-lat')), lng = parseFloat(root.getAttribute('data-ld-lng'));
    if (!isNaN(lat) && !isNaN(lng)) data.geo = { '@type': 'GeoCoordinates', latitude: lat, longitude: lng };
    var rating = parseFloat(root.getAttribute('data-ld-rating')), count = parseInt(root.getAttribute('data-ld-review-count'), 10);
    if (!isNaN(rating) && !isNaN(count) && count > 0) data.aggregateRating = { '@type': 'AggregateRating', ratingValue: rating, reviewCount: count, bestRating: 5 };
    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.setAttribute('data-bakehouse-jsonld', '');
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
  }

  function initSticky(section) {
    var bar = section.querySelector('[data-bh-sticky]');
    var card = section.querySelector('.bakehouse-visit__actions');
    if (!bar || !card || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 767px)');
    var pastActions = false;
    function apply() {
      var show = pastActions && mq.matches;
      bar.hidden = false;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('bakehouse-visit-sticky-open', show);
    }
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        // Show once the card's action buttons have scrolled above the viewport
        pastActions = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      });
      apply();
    }, { threshold: 0 }).observe(card);
    if (mq.addEventListener) mq.addEventListener('change', apply); else mq.addListener(apply);
  }

  function platformFromHref(href) {
    var h = String(href || '').toLowerCase();
    if (!h) return null;
    if (h.indexOf('toasttab.com/invoice') >= 0) return 'toast_catering';
    if (h.indexOf('toasttab.com') >= 0) return 'toast';
    if (h.indexOf('ubereats.com') >= 0 || h.indexOf('order.store') >= 0) return 'ubereats';
    if (h.indexOf('doordash.com') >= 0) return 'doordash';
    if (h.indexOf('grubhub.com') >= 0) return 'grubhub';
    if (h.indexOf('maps.app.goo.gl') >= 0 || h.indexOf('google.com/maps') >= 0 || h.indexOf('maps.apple.com') >= 0) return 'directions';
    if (h.indexOf('tel:') === 0) return 'call';
    if (h === '#delivery') return 'delivery_popup';
    return null;
  }

  function initTracking() {
    if (window.__bakehouseCtaTracking) return;
    window.__bakehouseCtaTracking = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
      if (!a) return;
      var platform = a.getAttribute('data-bh-cta') || platformFromHref(a.getAttribute('href'));
      if (!platform) return;
      var sectionEl = a.closest('.shopify-section');
      var meta = {
        location: a.getAttribute('data-bh-location') || (sectionEl ? sectionEl.id.replace(/^shopify-section-/, '') : 'page'),
        url: a.getAttribute('href'),
        page: window.location.pathname,
        viewport: window.matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
      };
      window.StatsigReady && window.StatsigReady.then(function (client) {
        if (client) client.logEvent('bakehouse_cta_click', platform, meta);
      });
    }, true);
  }

  // Hero "Order delivery" button (any link to #delivery) -> delivery popup; without <dialog>
  // support it smooth-scrolls to the in-page delivery row instead (scroll-margin clears the header)
  function initDeliveryPopup() {
    if (window.__bakehouseDeliveryPopup) return;
    window.__bakehouseDeliveryPopup = true;
    document.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('a[href="#delivery"]') : null;
      if (!a) return;
      var dialog = document.querySelector('[data-bh-delivery-popup]');
      if (dialog && typeof dialog.showModal === 'function') {
        e.preventDefault();
        if (!dialog.open) dialog.showModal();
        document.documentElement.classList.add('bakehouse-popup-open');
        return;
      }
      var target = document.getElementById('delivery');
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  function initPopupDialog(section) {
    var dialog = section.querySelector('[data-bh-delivery-popup]');
    if (!dialog) return;
    dialog.addEventListener('close', function () { document.documentElement.classList.remove('bakehouse-popup-open'); });
    dialog.addEventListener('click', function (e) {
      // Close on the X, or a tap on the backdrop (the dialog element itself, outside the inner panel)
      if (e.target === dialog || (e.target.closest && e.target.closest('[data-bh-popup-close]'))) dialog.close();
    });
  }

  function init() {
    document.querySelectorAll('.bakehouse-visit').forEach(function (section) {
      if (section.__bhInit) return;
      section.__bhInit = true;
      var root = section.querySelector('bakehouse-visit');
      if (root) initStatus(root);
      initSticky(section);
      initPopupDialog(section);
    });
    initTracking();
    initDeliveryPopup();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
